import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '健康性知识科普平台',
    url: 'https://your-domain.com/',
    description: '提供安全健康的成人知识科普、性教育资讯及正规平台推荐',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://your-domain.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '健康性知识科普平台',
    url: 'https://your-domain.com/',
    description: '致力于提供安全、科学、健康的性教育知识与资讯',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-123-4567',
      contactType: 'customer service',
    },
  };

  return (
    <>
      <SEOHead
        title="啪啪啪在线观看 - 安全健康的成人知识科普与性教育资讯平台"
        description="啪啪啪在线观看为您提供安全健康的成人知识科普、性教育资讯及正规平台推荐，帮助用户了解相关法规与健康知识，理性看待成人内容，保护个人隐私与网络安全。"
        keywords="啪啪啪在线观看,成人内容安全须知,在线观看隐私保护,成人性教育科普,正规平台推荐,网络安全防护,健康性知识"
        schema={{ ...websiteSchema, ...orgSchema }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}